import React from 'react';
import { motion } from 'framer-motion';
import { buttonTap } from '../../utils/animations';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  className = '',
  type = 'button',
  disabled = false 
}) => {
  
  const baseStyles = 'font-medium rounded transition-all duration-300 inline-flex items-center justify-center';
  
  const variants = {
    primary: 'bg-primary-brown text-white hover:bg-opacity-90 hover:shadow-lg',
    secondary: 'bg-primary-beige text-dark hover:bg-primary-tan',
    outline: 'border-2 border-primary-brown text-primary-brown hover:bg-primary-brown hover:text-white',
    ghost: 'text-primary-brown hover:bg-primary-beige'
  };
  
  const sizes = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };
  
  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      whileTap={!disabled ? buttonTap.tap : {}}
      whileHover={!disabled ? { y: -2 } : {}}
    >
      {children}
    </motion.button>
  );
};

export default Button;